import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth.guard';
import { MsalGuard } from '@azure/msal-angular';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./login/login.module').then((m) => m.LoginPageModule),

    // redirectTo: 'login',
    // pathMatch: 'full'
  },
  {
    path: 'automations',
    loadChildren: () =>
      import('./automations/automations.module').then(
        (m) => m.AutomationsPageModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'artifical-intelligence-generation',
    loadChildren: () =>
      import(
        './artifical-intelligence-generation/artifical-intelligence-generation.module'
      ).then((m) => m.ArtificalIntelligenceGenerationPageModule),
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./login/login.module').then((m) => m.LoginPageModule),
  },
  {
    path: 'signup',
    loadChildren: () =>
      import('./signup/signup.module').then((m) => m.SignupPageModule),
  },
  {
    path: 'profile',
    loadChildren: () =>
      import('./profile/profile.module').then((m) => m.ProfilePageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'password',
    loadChildren: () =>
      import('./password/password.module').then((m) => m.PasswordPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'email',
    loadChildren: () =>
      import('./email/email.module').then((m) => m.EmailPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'logo',
    loadChildren: () =>
      import('./logo/logo.module').then((m) => m.LogoPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'videos',
    loadChildren: () =>
      import('./videos/videos.module').then((m) => m.VideosPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'communication',
    loadChildren: () =>
      import('./disposition/communication/communication.module').then(
        (m) => m.CommunicationPageModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'applicants',
    loadChildren: () =>
      import('./recruiting/applicants/applicants.module').then(
        (m) => m.ApplicantsPageModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'applicant-information',
    loadChildren: () =>
      import(
        './recruiting/applicant-information/applicant-information.module'
      ).then((m) => m.ApplicantInformationPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'applicant-information/:id',
    loadChildren: () =>
      import(
        './recruiting/applicant-information/applicant-information.module'
      ).then((m) => m.ApplicantInformationPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'applicant-create-short-information',
    loadChildren: () =>
      import(
        './recruiting/applicant-create-short-information/applicant-create-short-information.module'
      ).then((m) => m.ApplicantCreateShortInformationPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'customer-request',
    loadChildren: () =>
      import('./disposition/customer-request/customer-request.module').then(
        (m) => m.CustomerRequestPageModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'customer-requests',
    loadChildren: () =>
      import('./disposition/customer-requests/customer-requests.module').then(
        (m) => m.CustomerRequestsPageModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'customer-request-create',
    loadChildren: () =>
      import(
        './disposition/customer-request-create/customer-request-create.module'
      ).then((m) => m.CustomerRequestCreatePageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'folder/:id',
    loadChildren: () =>
      import('./folder/folder.module').then((m) => m.FolderPageModule),
  },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./dashboard/dashboard.module').then((m) => m.DashboardPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'new-job-offer',
    loadChildren: () =>
      import('./job-offer/new-job-offer/new-job-offer.module').then(
        (m) => m.NewJobOfferPageModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'job-offers',
    loadChildren: () =>
      import('./job-offer/job-offers/job-offers.module').then(
        (m) => m.JobOffersPageModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'job-offer-information',
    children: [
      {
        path: '',
        loadChildren: () =>
          import(
            './job-offer/job-offer-information/job-offer-information.module'
          ).then((m) => m.JobOfferInformationPageModule),
        canActivate: [AuthGuard],
      },
      {
        path: ':id',
        loadChildren: () =>
          import(
            './job-offer/job-offer-information/job-offer-information.module'
          ).then((m) => m.JobOfferInformationPageModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'applicant-information/:id',
        loadChildren: () =>
          import(
            './recruiting/applicant-information/applicant-information.module'
          ).then((m) => m.ApplicantInformationPageModule),
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: 'job-offer-information/:id',
    loadChildren: () =>
      import(
        './job-offer/job-offer-information/job-offer-information.module'
      ).then((m) => m.JobOfferInformationPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'delete-job-offer',
    loadChildren: () =>
      import('./job-offer/delete-job-offer/delete-job-offer.module').then(
        (m) => m.DeleteJobOfferPageModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'contracts',
    loadChildren: () =>
      import('./contract/contracts/contracts.module').then(
        (m) => m.ContractsPageModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'new-contract',
    loadChildren: () =>
      import('./contract/new-contract/new-contract.module').then(
        (m) => m.NewContractPageModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'contract-information/:id',
    loadChildren: () =>
      import(
        './contract/contract-information/contract-information.module'
      ).then((m) => m.ContractInformationPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'campaigns',
    loadChildren: () =>
      import('./campaign/campaigns/campaigns.module').then(
        (m) => m.CampaignsPageModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'create-campaign',
    loadChildren: () =>
      import('./campaign/create-campaign/create-campaign.module').then(
        (m) => m.CreateCampaignPageModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'appointments',
    loadChildren: () =>
      import('./appointment/appointments/appointments.module').then(
        (m) => m.AppointmentsPageModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'create-appointment',
    loadChildren: () =>
      import('./appointment/create-appointment/create-appointment.module').then(
        (m) => m.CreateAppointmentPageModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'appointment-information',
    loadChildren: () =>
      import(
        './appointment/appointment-information/appointment-information.module'
      ).then((m) => m.AppointmentInformationPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'campaign-information',
    loadChildren: () =>
      import(
        './appointment/campaign-information/campaign-information.module'
      ).then((m) => m.CampaignInformationPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'communication-dashboard',
    loadChildren: () =>
      import('./communication/dashboard/dashboard.module').then(
        (m) => m.DashboardPageModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'team-management',
    loadChildren: () =>
      import('./team-management/team-management.module').then(
        (m) => m.TeamManagementPageModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'customer/:customerId/teammember/:teammemberId/kid/:kidId',
    loadChildren: () =>
      import('./signup/create-password/create-password.module').then(
        (m) => m.CreatePasswordPageModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'create-workflow',
    loadChildren: () =>
      import('./communication/create-workflow/create-workflow.module').then(
        (m) => m.CreateWorkflowPageModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'edit-workflow',
    loadChildren: () =>
      import('./communication/edit-workflow/edit-workflow.module').then(
        (m) => m.EditWorkflowPageModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'edit-workflow/:[id,name,description,type,action,create]',
    loadChildren: () =>
      import('./communication/edit-workflow/edit-workflow.module').then(
        (m) => m.EditWorkflowPageModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'automations/email',
    loadChildren: () =>
      import('./automations/email/email.module').then((m) => m.EmailPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'preview-file/:applicantId/:id',
    loadChildren: () =>
      import('./preview-file/preview-file.module').then(
        (m) => m.PreviewFilePageModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'news',
    loadChildren: () =>
      import('./news/news.module').then((m) => m.NewsPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'howto',
    loadChildren: () =>
      import('./howto/howto/howto.module').then((m) => m.HowtoPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'create-howto',
    loadChildren: () =>
      import('./howto/create-howto/create-howto.module').then(
        (m) => m.CreateHowtoPageModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'help',
    loadChildren: () =>
      import('./help/help.module').then((m) => m.HelpPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'settings',
    loadChildren: () =>
      import('./settings/settings.module').then((m) => m.SettingsPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'upload',
    loadChildren: () =>
      import('./upload/upload.module').then((m) => m.UploadPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'integrations',
    loadChildren: () =>
      import('./integrations/integrations.module').then(
        (m) => m.IntegrationsPageModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'conditional-flowchart',
    loadChildren: () =>
      import('./conditional-flowchart/conditional-flowchart.module').then(
        (m) => m.ConditionalFlowchartPageModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'add-nonde-popover',
    loadChildren: () =>
      import('./add-node-popover/add-node-popover.module').then(
        (m) => m.AddNodePopoverPageModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'tutorial-popover',
    loadChildren: () =>
      import('./tutorial-popover/tutorial-popover.module').then(
        (m) => m.TutorialPopoverPageModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'tutorial-intro',
    loadChildren: () =>
      import('./tutorial-intro/tutorial-intro.module').then(
        (m) => m.TutorialIntroPageModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'video-modal',
    loadChildren: () =>
      import('./video-image-answer-modal/video-image-answer-modal.module').then(
        (m) => m.VideoImageAnswerModalPageModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'matching',
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./matching/matching.module').then(
            (m) => m.MatchingPageModule,
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'applicant-information/:id',
        loadChildren: () =>
          import(
            './recruiting/applicant-information/applicant-information.module'
          ).then((m) => m.ApplicantInformationPageModule),
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: 'blacklist',
    loadChildren: () =>
      import('./blacklist/blacklist.module').then((m) => m.BlacklistPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'update-all-job-offers',
    loadChildren: () =>
      import(
        './job-offer/update-all-job-offers/update-all-job-offers.module'
      ).then((m) => m.UpdateAllJobOffersPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'edit-message-modal',
    loadChildren: () =>
      import('./edit-message-modal/edit-message-modal.module').then(
        (m) => m.EditMessageModalPageModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'edit-message-modal-for-new-job-offer-page',
    loadChildren: () =>
      import(
        './edit-message-modal-for-new-job-offer-page/edit-message-modal-for-new-job-offer-page.module'
      ).then((m) => m.EditMessageModalForNewJobOfferModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'get-data-for-ai',
    loadChildren: () =>
      import('./ai-studio/get-data-for-ai/get-data-for-ai.module').then(
        (m) => m.GetDataForAIPageModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'set-dispo-money-popover',
    loadChildren: () =>
      import(
        './dashboard/set-dispo-money-popover/set-dispo-money-popover.module'
      ).then((m) => m.SetDispoMoneyPopoverPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'create-custom-video',
    loadChildren: () =>
      import('./howto/create-custom-video/create-custom-video.module').then(
        (m) => m.CreateCustomVideoPageModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'reporting',
    loadChildren: () =>
      import('./reporting/reporting.module').then((m) => m.ReportingPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'new-assessment-test',
    loadChildren: () =>
      import(
        './assessment-test/new-assessment-test/new-assessment-test.module'
      ).then((m) => m.NewAssessmentTestPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'assessment-tests',
    loadChildren: () =>
      import('./assessment-test/assessment-tests/assessment-tests.module').then(
        (m) => m.AssessmentTestsPageModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'mona-communication-list',
    loadChildren: () =>
      import(
        './mona-communication/mona-communication-list/mona-communication-list.module'
      ).then((m) => m.MonaCommunicationListPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'assessment-test-information/:id',
    loadChildren: () =>
      import(
        './assessment-test/assessment-test-information/assessment-test-information.module'
      ).then((m) => m.AssessmentTestInformationPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'insights',
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./insights/reporting/reporting.module').then(
            (m) => m.ReportingPageModule,
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'reporting',
        loadChildren: () =>
          import('./insights/reporting/reporting.module').then(
            (m) => m.ReportingPageModule,
          ),
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: 'contact-form',
    loadChildren: () =>
      import('./contact-form/contact-form.module').then(
        (m) => m.ContactFormPageModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'data-warehouse',
    loadChildren: () =>
      import('./data-warehouse/data-warehouse.module').then(
        (m) => m.DataWarehousePageModule,
      ),
    canActivate: [AuthGuard]
  },
  {
    path: 'mona-agent-chat',
    loadChildren: () =>
      import('./mona-app/mona-app.module').then(
        (m) => m.MonaAppModule,
      ),
  },
  {
    path: 'mona-agent-builder',
    loadChildren: () => import('./mona-agent-builder/mona-agent-builder.module').then(m => m.MonaAgentBuilderPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'payment',
    loadChildren: () =>
      import('./payment/payment.module').then((m) => m.PaymentPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'agents',
    loadChildren: () =>
      import('./agents/agents.module').then((m) => m.AgentsPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'agent-templates',
    loadChildren: () =>
      import('./agent-templates/agent-templates.module').then(
        (m) => m.AgentTemplatesPageModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'create-agent',
    loadChildren: () =>
      import('./create-agent/create-agent.module').then(
        (m) => m.CreateAgentPageModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'agent-edit/:id',
    loadChildren: () =>
      import('./agent-edit/agent-edit.module').then(
        (m) => m.AgentEditPageModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'chatmona',
    loadChildren: () =>
      import('./chatmona/chatmona.module').then((m) => m.ChatmonaPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'pricing',
    loadChildren: () =>
      import('./pricing/pricing.module').then((m) => m.PricingPageModule),
  },
  {
    path: 'activity-center',
    loadChildren: () =>
      import('./activity-center/activity-center.module').then(
        (m) => m.ActivityCenterPageModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'data-warehouse',
    loadChildren: () =>
      import('./data-warehouse/data-warehouse.module').then(
        (m) => m.DataWarehousePageModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'terms-of-use',
    loadChildren: () =>
      import('./policies/terms-of-use/terms-of-use.module').then(
        (m) => m.TermsOfUsePageModule,
      ),
  },
  {
    path: 'privacy-policy',
    loadChildren: () =>
      import('./policies/privacy-policy/privacy-policy.module').then(
        (m) => m.PrivacyPolicyPageModule,
      ),
  },
  {
    path: 'emailverify/:id',
    loadChildren: () =>
      import('./emailverify/emailverify.module').then(
        (m) => m.EmailverifyPageModule,
      ),
  },
  {
    path: 'success',
    loadChildren: () =>
      import('./success/success.module').then((m) => m.SuccessPageModule),
  },
  {
    path: 'cancel',
    loadChildren: () =>
      import('./cancel/cancel.module').then((m) => m.CancelPageModule),
  },
  {
    path: 'account-registered',
    loadChildren: () =>
      import('./account-registered/account-registered.module').then(
        (m) => m.AccountRegisteredPageModule,
      ),
  },
  {
    path: 'account-confirmation/:id',
    loadChildren: () =>
      import('./account-confirmation/account-confirmation.module').then(
        (m) => m.AccountConfirmationPageModule,
      ),
  },
  {
    path: 'controlpanel',
    loadChildren: () =>
      import('./controlpanel/controlpanel.module').then(
        (m) => m.ControlpanelPageModule,
      ),
  },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./community/dashboard/dashboard.module').then(
        (m) => m.DashboardPageModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'invite',
    loadChildren: () =>
      import('./community/invite/invite.module').then(
        (m) => m.InvitePageModule,
      ),
  },
  {
    path: 'rewards',
    loadChildren: () =>
      import('./rewards/rewards.module').then((m) => m.RewardsPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'video-library',
    loadChildren: () =>
      import('./video-libary/video-libary.module').then(
        (m) => m.VideoLibaryPageModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'video-admin',
    loadChildren: () =>
      import('./video-admin/video-admin.module').then(
        (m) => m.VideoAdminPageModule,
      ),
  },
  {
    path: 'notify-admin',
    loadChildren: () =>
      import('./notify-admin/notify-admin.module').then(
        (m) => m.NotifyAdminPageModule,
      ),
  },
  {
    path: 'mona-communication-list',
    loadChildren: () =>
      import(
        './mona-communication/mona-communication-list/mona-communication-list.module'
      ).then((m) => m.MonaCommunicationListPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'recruiting-communication',
    loadChildren: () => import('./recruiting-communication/recruiting-communication.module').then(m => m.RecruitingCommunicationPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'onboarding',
    loadChildren: () => import('./onboarding/onboarding.module').then(m => m.OnboardingPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'workspace',
    loadChildren: () => import('./workforce/workspace/workspace.module').then(m => m.WorkspacePageModule)
  },
  {
    path: 'agent',
    loadChildren: () => import('./workforce/agent/agent.module').then(m => m.AgentPageModule)
  },
  {
    path: 'agent/:id',
    loadChildren: () => import('./workforce/agent/agent.module').then(m => m.AgentPageModule)
  },
  {
    path: 'mona-agent-builder',
    loadChildren: () => import('./mona-agent-builder/mona-agent-builder.module').then(m => m.MonaAgentBuilderPageModule)
  },
  {
    path: 'profile-builder',
    loadChildren: () => import('./profile-builder/profile-builder.module').then(m => m.ProfileBuilderPageModule)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
